module.exports = __webpack_public_path__ + "static/media/undraw_Male_avatar_g98d.af7aa9a2.png";